import React, {Component} from 'react'
import styles from './FJProjectName.module.less';
import FJNameInput from "fj-components/FJNameInput";
import FJUtil from "../../../util/FJUtil";

class FJProjectName extends Component {

  /**
   * @description 修改工程名字
   * @param value
   * @private
   */
  _onChange = (value) => {
    this.props.updateProjectName(value);
  };

  /**
   * @description 失去焦点触发
   * @param value
   * @private
   */
  _onBlur = (value) => {
    if (value.trim() === '' || FJUtil.testStr(value)) {
      this.props.updateProjectOldName(value.trim() !== '');
    } else {
      this.props.updateProjectName(value);
      this.props.editProjectNameInNetwork();
    }
  };

  render() {
    let {
      projectName,
    } = this.props;

    return (
        <div className={styles.project_edit}>
          <FJNameInput onChange={this._onChange}
                       onBlur={this._onBlur}
                       maxLength={50}
                       value={projectName}
                       className={styles.input}
          />
        </div>
    )
  }
}

export default FJProjectName;
